import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { MaskedTextBox, MaskedTextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { FormFieldWrapper, FormFieldWrapperProps } from '../FormFieldWrapper';

interface MaskedInputFieldProps extends FieldRenderProps {
  mask: string;
  isLoading?: boolean;
  renderFieldWrapper?: (props: FormFieldWrapperProps) => React.ReactNode;
}

export const FormMaskedInput: React.FC<MaskedInputFieldProps> = fieldRenderProps => {
  const { mask, onChange, disabled, isLoading, renderFieldWrapper } = fieldRenderProps;

  const handleChange = (event: MaskedTextBoxChangeEvent) => {
    if (onChange) {
      onChange({
        value: event.target.rawValue
      });
    }
  };

  const inputElement = (
    <MaskedTextBox
      name={fieldRenderProps.name}
      valid={fieldRenderProps.valid}
      value={fieldRenderProps.value}
      defaultValue={fieldRenderProps.defaultValue}
      onChange={handleChange}
      mask={mask}
      validationMessage={fieldRenderProps.validationMessage || undefined}
      disabled={disabled}
    />
  );

  const wrapperProps: FormFieldWrapperProps = {
    validationMessage: fieldRenderProps.validationMessage,
    value: fieldRenderProps.value,
    touched: fieldRenderProps.touched,
    id: fieldRenderProps.id,
    valid: fieldRenderProps.valid,
    disabled: fieldRenderProps.disabled,
    hint: fieldRenderProps.hint,
    label: fieldRenderProps.label,
    wrapperStyle: fieldRenderProps.wrapperStyle,
    optional: fieldRenderProps.optional,
    modified: fieldRenderProps.modified,
    visited: fieldRenderProps.visited,
    onChange,
    onFocus: fieldRenderProps.onFocus,
    onBlur: fieldRenderProps.onBlur,
    name: fieldRenderProps.name,
    isLoading,
    children: inputElement
  };

  if (renderFieldWrapper) {
    return renderFieldWrapper(wrapperProps);
  }

  return (
    <FormFieldWrapper
      validationMessage={wrapperProps.validationMessage}
      value={wrapperProps.value}
      touched={wrapperProps.touched}
      id={wrapperProps.id}
      valid={wrapperProps.valid}
      disabled={wrapperProps.disabled}
      hint={wrapperProps.hint}
      label={wrapperProps.label}
      wrapperStyle={wrapperProps.wrapperStyle}
      optional={wrapperProps.optional}
      modified={wrapperProps.modified}
      visited={wrapperProps.visited}
      onChange={wrapperProps.onChange}
      onFocus={wrapperProps.onFocus}
      onBlur={wrapperProps.onBlur}
      name={wrapperProps.name}
      isLoading={wrapperProps.isLoading}
    >
      {inputElement}
    </FormFieldWrapper>
  );
};
